<template>
    <section class="home-container">
        <MasterPage>
            <div slot="title-icon">
                <Icon type="md-paper" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="问卷名称：">
                            <Select v-model="selectParams.questionnaireId" filterable clearable placeholder="请选择">
                                <Option v-for="item in questionnaireAllList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="infoModel" title="问卷结果" fullscreen>
            <div style="width: 100%;background-color: #eeeeee;padding: 50px 30px">
                <Card shadow style="border-radius: 10px">
                    <p class="questionnaireTitle">{{questionnaireResultInfo.name}}</p>
                    <h4 style="text-align: center;padding: 10px 0px">{{questionnaireResultInfo.introduction}}</h4>
                    <Divider>
                        <span style="font-size: 20px;color: #2d8cf0">
                            填写情况：{{questionnaireResultInfo.isUserAnswer?'本人填写':'后台代填'}}（分数：{{questionnaireResultInfo.point}}）
                        </span>
                    </Divider>
                    <div class="questionnaireQuestion">
                        <div style="width: 600px;padding: 15px 0" v-for="question in questionnaireResultInfo.questionVOList" :key="question.id">
                            <div class="questionTitle">
                                <label v-if="question.required" style="color: red;position: absolute">*</label>
                                <div style="padding-left: 15px">
                                    {{question.index}}、{{question.text}}
                                    <span style="font-size: 16px;color: #B4B4B4;padding-left: 10px">({{question.type}})</span>
                                </div>
                            </div>
                            <div v-if="question.type == '文本'">
                                <div class="my_divz">{{question.optionList[0].answer}}</div>
                            </div>
                            <div v-if="question.type == '单选'">
                                <div style="padding-left: 30px">
                                    <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList" style="margin: 5px 0;line-height: 35px;"  :key="Option.id">
                                        <span v-if="Option.isSelected" class="input_iocns">
                                            <i class="iconfont" style="font-size: 16px">&#xe735;</i>
                                        </span>
                                        <span v-if="!Option.isSelected" class="input_iocns">
                                            <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                        </span>
                                        <span style="font-size: 18px;padding-left: 10px">{{Option.text}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="question.type == '多选'">
                                <div style="padding-left: 30px">
                                    <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList" style="margin: 5px 0;line-height: 35px;" :key="Option.id">
                                        <span v-if="Option.isSelected" class="input_iocns">
                                            <i class="iconfont" style="font-size: 16px">&#xe738;</i>
                                        </span>
                                        <span v-if="!Option.isSelected" class="input_iocns">
                                            <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                        </span>
                                        <span style="font-size: 18px;padding-left: 10px;">{{Option.text}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="question.type == '单选文本'">
                                <div style="padding-left: 30px">
                                    <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList" style="margin: 5px 0;line-height: 35px;" :key="Option.id">
                                        <span v-if="Option.isSelected" class="input_iocns">
                                            <i class="iconfont" style="font-size: 16px">&#xe735;</i>
                                        </span>
                                        <span v-if="!Option.isSelected" class="input_iocns">
                                            <i class="iconfont" style="font-size: 16px">&#xe73d;</i>
                                        </span>
                                        <span v-if="Option.format ==''" style="font-size: 18px;padding-left: 10px;">{{Option.text}}</span>
                                        <span v-if="Option.format !=''"
                                              style="font-size: 18px;padding-left: 10px;position: absolute;">
                                            <div v-if="Option.answer ==''" class="my_divz" style="width: 200px;background-color: #f5f5f5">{{Option.answer}}</div>
                                            <div v-if="Option.answer !=''" class="my_divz" style="width: 200px">{{Option.answer}}</div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="question.type == '多选文本'">
                                <div style="padding-left: 30px">
                                    <div v-if="Option.id && Option.id != ''" v-for="Option in question.optionList" style="margin: 5px 0;line-height: 35px;" :key="Option.id">
                                        <span v-if="Option.isSelected" class="input_iocns">
                                            <i class="iconfont" style="font-size: 16px">&#xe738;</i>
                                        </span>
                                        <span v-if="!Option.isSelected" class="input_iocns">
                                            <i class="iconfont" style="font-size: 16px">&#xe73e;</i>
                                        </span>
                                        <span v-if="Option.format ==''" style="font-size: 18px;padding-left: 10px;">{{Option.text}}</span>
                                        <span v-if="Option.format !=''"
                                              style="font-size: 18px;padding-left: 10px;position: absolute;">
                                            <div v-if="Option.answer ==''" class="my_divz" style="width: 200px;background-color: #f5f5f5">{{Option.answer}}</div>
                                            <div v-if="Option.answer !=''" class="my_divz" style="width: 200px">{{Option.answer}}</div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Divider>
                        开始时间:{{questionnaireResultInfo.startTime | dateTimeToString }} &nbsp;&nbsp;&nbsp;&nbsp;
                        结束时间:{{questionnaireResultInfo.endTime | dateTimeToString }}
                    </Divider>
                    <Divider>
                        <span style="font-size: 20px;color: #2d8cf0">
                            填写时间：{{questionnaireResultInfo.resultTime | dateTimeToString}}
                        </span>
                    </Divider>
                </Card>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        props: {
            user: {
                type: Object,
                default: null
            },
        },
        data(){
            return{
                modalDisplay: true,
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '问卷名称',
                        key: 'questionnaireName',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '用户患者',
                        key: 'userName',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '本人填写',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (params.row.isUserAnswered){
                                return h('span', '本人填写')
                            }else{
                                return h('span', '后台代填')
                            }
                        }
                    },
                    {
                        title: '填写时间',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let value= params.row.createTime
                            if (value==undefined || value.length <=0) return
                            let time = new Date(value)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hs = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h('span', y+'-'+m+'-'+d+' '+hs+':'+mm+':'+s)
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                        loading:this.infoLoading
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            // if (this.dataList[params.index].isDeleted){
                            //     Buttons.push(
                            //         h('Button', {
                            //             props: {
                            //                 type: 'primary',
                            //                 icon:'md-unlock',
                            //                 label:"small",
                            //             },
                            //             style: {
                            //                 marginRight: '5px'
                            //             },
                            //             on: {
                            //                 click: () => {
                            //                     this.reuseItem_modal(this.dataList[params.index])
                            //                 }
                            //             }
                            //         }, '启用')
                            //     )
                            // }else{
                            //     Buttons.push(
                            //         h('Button', {
                            //             props: {
                            //                 type: 'primary',
                            //                 icon:'md-create',
                            //                 label:"small",
                            //             },
                            //             style: {
                            //                 marginRight: '5px'
                            //             },
                            //             on: {
                            //                 click: () => {
                            //                     this.updateItem_modal(this.dataList[params.index])
                            //                 }
                            //             }
                            //         }, '编辑')
                            //     )
                            //     Buttons.push(
                            //         h('Button', {
                            //             props: {
                            //                 type: 'error',
                            //                 icon:'md-trash',
                            //                 label:"small",
                            //             },
                            //             style: {
                            //                 marginRight: '5px'
                            //             },
                            //             on: {
                            //                 click: () => {
                            //                     this.deleteItem_modal(this.dataList[params.index])
                            //                 }
                            //             }
                            //         }, '禁用')
                            //     )
                            // }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                infoLoading:false,
                userAllList:[],
                questionnaireAllList:[],
                selectParams:{
                    userId: this.user.id,
                    questionnaireId:"",
                },
                questionnaireResultInfo:'',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
//            this.selectParams.userId = this.$route.params.patient.id
            this.selectParams.userId = this.user.id
            this.pageFindItem()
            this.findAllUser()
            this.findAllQuestionnaire()
        },
        methods:{
            cancel() {
                this.$router.back(-1)
            },
            formatQuestionnaire(labels, selectedData){
                if (selectedData[labels.length - 1] == undefined) return
                return selectedData[labels.length - 1].label
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            findAllQuestionnaire(){
                this.$http.post('questionnaire/list',{
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.questionnaireAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'问卷查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('questionnaire/getQuestionnaireResult',{
                    userId:this.selectParams.userId == undefined ? "" : this.selectParams.userId,
                    questionnaireId:this.selectParams.questionnaireId,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'问卷列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            infoItem_modal(item){
                this.infoLoading = true
                this.$http.post('questionnaire/getQuestionnaireResultById',{
                    questionnaireAnswerId:item.id,
                }).then(function (res) {
                    this.infoLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.infoModel = true
                        this.questionnaireResultInfo= msg.data[0]
                    }else {
                        this.$Notice.error({title:'问卷结果查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.infoLoading = false
                    this.myError(res.body)
                })

            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    @font-face {
        font-family: 'iconfont';  /* project id 1253004 */
        src: url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.eot');
        src: url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.woff') format('woff'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.svg#iconfont') format('svg');
    }

    .iconfont{
        font-family:"iconfont" !important;
        font-size:14px;font-style:normal;
        padding-right: 5px;
        -webkit-font-smoothing: antialiased;
        -webkit-text-stroke-width: 0.2px;
        -moz-osx-font-smoothing: grayscale;
    }

    .home-container{

    }

    .questionnaireTitle{
        text-align: center;
        font-size: 42px;
        font-weight: bold;
    }

    .questionnaireQuestion{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-bottom: 30px;
    }

    .questionTitle{
        font-size: 20px;
        line-height: 50px;
        letter-spacing: 3px;
        position: relative;
    }

    .my_Button{
        height: 45px;
        border: 0;
        padding: 5px 13px 6px;
        background-color: rgba(0,0,0,0);
    }

    .my_Button:focus{
        box-shadow: 0 0 0 0;
    }

    .my_divz{
        height: 35px;
        padding: 4px 7px;
        border: 1px solid #dcdee2;
        border-radius: 4px;
        background-color: #fff;
        line-height: 27px;
        font-size: 18px;
    }
</style>


